import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=570b1bc9&scoped=true&"
import script from "./NewsCreate.vue?vue&type=script&lang=js&"
export * from "./NewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./NewsCreate.vue?vue&type=style&index=0&id=570b1bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b1bc9",
  null
  
)

export default component.exports